import uuidv4 from 'uuid/v4';

/**
 * Abstracts the uuidv4 module to make it easier to mock in unit tests
 * See HomeApiSagaTests.ts for example
 */
export const generateUuid = (): string => {
  return uuidv4();
};
